import React from 'react';
import { Optional } from 'types';
import { ProgressBar, TProgressBarProps } from './ProgressBar';
import { ProgressBarLoader } from './ProgressBarLoader';

type TProps = Optional<TProgressBarProps, 'status'>;

export const ProgressBarWrapper = ({ status, ...props }: TProps) => {
  if (!status) {
    return <ProgressBarLoader className={props.className} />;
  }
  if (status === 'expired') {
    return null;
  }
  return <ProgressBar status={status} {...props} />;
};
